/**
 * @namespace SocialEmbeds
 * @aka SWR.SocialEmbeds
 */
SWR.SocialEmbeds = (function ($) {

  return {
    embedTypes: [
      {
        "name": "Apester",
        "techname": "apester",
        "nOrM": "n"
      },
      {
        "name": "Facebook",
        "techname": "facebook",
        "nOrM": "n"
      },
      {
        "name": "Giphy",
        "techname": "giphy",
        "nOrM": "n"
      },
      {
        "name": "Instagram",
        "techname": "instagram",
        "nOrM": "n"
      },
      {
        "name": "Mastodon",
        "techname": "mastodon",
        "nOrM": "n"
      },
      {
        "name": "Kurznachrichtendienst X",
        "techname": "twitter",
        "nOrM": "m"
      },
      {
        "name": "Spotify",
        "techname": "spotify",
        "nOrM": "n"
      },
      {
        "name": "TikTok",
        "techname": "tiktok",
        "nOrM": "n"
      },
      {
        "name": "Timeline",
        "techname": "timeline",
        "nOrM": "n"
      },
      {
        "name": "Twitch",
        "techname": "twitch",
        "nOrM": "n"
      },
      {
        "name": "Vimeo",
        "techname": "vimeo",
        "nOrM": "n"
      },
      {
        "name": "YouTube",
        "techname": "youtube",
        "nOrM": "n"
      }
    ],

    createSwitch: function (type, cookie) {
      if (!(type && cookie)) {
        return -1;
      }

      var socialEmbed = this.embedTypes.find(({techname}) => techname === cookie);

      if('undefined' === typeof socialEmbed){
        return -1;
      }

      if ('datawrapper' !== type) {
        return COMMON.Utils.template(
          '<div class="switch">' +
          '<label for="embed-{plattform}-embedconsent-{id}">' +
          '<input type="checkbox" id="embed-{plattform}-embedconsent-{id}" name="{plattform}-embedconsent" value="{plattform}-embedconsent" data-toggle="embedconsent" role="switch" data-type="{plattform}" data-cookie="{cookie}" {checked}>' +
          '<span class="switch-wrapper"><span class="form-control-indicator"></span></span>' +
          '<span class="trackname">{label}</span>' +
          '</label>' +
          '</div>', {
            'id': COMMON.Utils.uuid(),
            'plattform': type,
            'cookie': cookie,
            'checked': this.getPermission(cookie) ? 'checked' : '',
            'label': 'Inhalte ' + (socialEmbed.nOrM === 'n' ? 'von ' : 'vom ') + socialEmbed.name + ' immer anzeigen'
          });
      }
    },

    switchInfo: function (type, cookie) {
      if (!(type && cookie)) {
        return -1;
      }

      var socialEmbed = this.embedTypes.find(({techname}) => techname === cookie);

      if('undefined' === typeof socialEmbed){
        return -1;
      }

      return COMMON.Utils.template('<p class="small">{info}</p>', {
        'info': this.infoText(this.getPermission(cookie), socialEmbed.name, socialEmbed.nOrM)
      });
    },

    infoText: function (permission, name, nOrM) {
      if (permission) {
        return 'Sie haben erlaubt, dass wir Ihnen hier diesen Inhalt ' + (nOrM === 'n' ? 'von ' : 'vom ') + name + ' zeigen und damit direkt eine Verbindung ' +
          (nOrM === 'n' ? 'zu ' : 'zum ') + name + ' aufgebaut wird. Mehr dazu finden Sie in unserer <a class="link link-inline" href="/datenschutz">Datenschutzerklärung</a>.';
      } else {
        return 'An dieser Stelle möchten wir Ihnen gerne Inhalte ' + (nOrM === 'n' ? 'von ' : 'vom ') + name + ' zeigen.<br>' +
          'Wir stellen die Verbindung ' + (nOrM === 'n' ? 'zu ' : 'zum ') + name + ' erst her, wenn Sie dies erlauben. ' +
          'Mehr dazu finden Sie in unserer <a class="link link-inline" href="' + window.location.origin + '/datenschutz" target="_blank">Datenschutzerklärung</a>.'
      }
    },

    setPermission: function (cookie) {
      var cookieName = "embed." + cookie;

      try {
        COMMON.Storage.local.setItem(cookieName, "true",);
      } catch (e) {
        console.log('Freigabe konnte nicht gespeichert werden.');
      }
    },

    removePermission: function (cookie) {
      var cookieName = "embed." + cookie;
      try {
        COMMON.Storage.local.removeItem(cookieName);
      } catch (e) {
        console.log('Freigabe konnte nicht gelöscht werden.');
      }
    },

    getPermission: function (cookie) {
      var cookieName = "embed." + cookie;
      return !!(COMMON.Storage.session.getItem(cookieName) || COMMON.Storage.local.getItem(cookieName));
    },

    bindChanges: function (id) {
      var self = this;
      //Eine Checkbox der Social-Embeds wird geklickt
      $(document).on('change', '[id="' + id + '"][data-toggle="embedconsent"]', function () {
        var cookieName = $(this).attr('data-cookie');
        var storage = self.getPermission(cookieName);

        if ('undefined' === typeof storage || storage === false) {
          //Erlauben
          self.setPermission(cookieName);
        } else {
          //Nicht erlauben
          self.removePermission(cookieName);
        }
      });
    }
  };
})(window.jQuery);
